import PriceListComponent from "../components/PriceListComponent";
import { useCatalog } from "../context/CatalogContext";
import ModalComponent from "../components/ModalComponent";
import AvailabilitySection from "../components/AvailabilitySection";
import { ContactData } from "../data-types/api-client/api-contacts";
import { IoDocumentTextSharp } from "react-icons/io5";

import React, { useState } from "react";

interface ContactProps {
  contact: ContactData | undefined; // Accept ContactData as a prop
}

const PriceList: React.FC<ContactProps> = ({ contact }) => {
  const { provisionData } = useCatalog();
  const numberOfProducts =
    contact?.productsCount && Math.floor(contact?.productsCount / 10) * 10;

  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="flex flex-col items-center justify-center h-full w-full justify-self-center pb-8 2xl:w-3/4 bg-custom-white">
      <div className="bg-custom-gray flex flex-col justify-self-center items-center h-full md:px-20 sm:px-8 px-4 w-full gap-3 py-0 pb-8">
        <div className="flex w-full items-center gap-2 pt-4">
          <span className="flex items-center justify-center w-9 h-9 rounded-xl text-custom-red bg-custom-white">
            <IoDocumentTextSharp className="text-lg" />
          </span>

          <h2 className="flex w-full justify-start items-center uppercase text-custom-blue font-semibold text-base">
            Cenník produktov a služieb
          </h2>
        </div>
        <div className="flex lg:flex-row flex-col w-full xl:items-start items-center justify-self-center h-full xl:gap-8 gap-8">
          <div className="flex w-full flex-col px-8 pt-8 w-full rounded-lg gap-4 bg-custom-white shadow-sm self-stretch">
            <h1 className="xl:text-4xl lg:text-3xl sm:text-4xl text-2xl font-semibold text-custom-blue tracking-wide text-center lg:text-left sm:normal-case uppercase">
              Prehľadný cenník všetkých produktov a služieb
            </h1>
            <div className="mx-auto h-1 w-20 rounded-full bg-custom-salmon lg:mx-0 my-1" />
            <div className="flex flex-col text-custom-atrament gap-4 lg:text-left text-center lg:text-lg sm:text-lg text-base text-base font-normal font-roboto">
              <p>
                V našom cenníku nájdete aktuálne ceny produktov a služieb, ktoré
                sú k dispozícii na prenájom.
              </p>
              <p>
                Snažíme sa ponúkať kvalitné vybavenie za dostupné ceny, aby ste
                mali všetko potrebné pre vašu prácu či projekt.
              </p>
            </div>
            {/* Price list */}
            <div className="flex justify-center lg:justify-start mt-4 mb-12">
              {provisionData?.priceList && (
                <PriceListComponent
                  provisionData={provisionData}
                  contactData={contact}
                />
              )}
            </div>
          </div>

          <div className="flex w-full lg:h-full justify-self-center">
            <AvailabilitySection
              imageSrc="images/generator-zvaracka.png"
              contact={contact?.contact.mobileConsultancy}
            />
          </div>

          <ModalComponent modalOpen={modalOpen} closeModal={closeModal} />
        </div>
      </div>
    </div>
  );
};

export default PriceList;
